import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
export function Navigation() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    if (location.pathname !== '/') {
      navigate('/');
      // Small delay to allow navigation to complete
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
    setMobileMenuOpen(false);
  };
  const handleApplyClick = () => {
    navigate('/application');
    setMobileMenuOpen(false);
  };
  return <nav className={`fixed top-0 w-full z-40 transition-all duration-300 border-b ${isSticky ? 'bg-black/90 backdrop-blur-md border-zinc-800 py-3' : 'bg-black border-transparent py-5'}`} data-id="element-511">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-512">
        <div className="flex justify-between items-center" data-id="element-513">
          <div className="flex items-center cursor-pointer" onClick={() => navigate('/')} data-id="element-514">
            {/* Using text logo for cleaner look if image doesn't match black theme, or keep image if transparent */}
            <div className="text-2xl font-bold tracking-tighter text-white" data-id="element-515">
              Vantage Capital Group
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-516">
            <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-white font-medium transition-colors text-sm tracking-wide" data-id="element-517">
              Services
            </button>
            <button onClick={() => scrollToSection('how-it-works')} className="text-gray-400 hover:text-white font-medium transition-colors text-sm tracking-wide" data-id="element-518">
              How It Works
            </button>
            <button onClick={() => scrollToSection('about')} className="text-gray-400 hover:text-white font-medium transition-colors text-sm tracking-wide" data-id="element-519">
              About
            </button>
            <button onClick={handleApplyClick} className="bg-white text-black px-6 py-2.5 rounded-full font-bold hover:bg-gray-200 transition-colors shadow-sm text-sm tracking-wide" data-id="element-520">
              Get Started
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden text-white p-2" data-id="element-521">
            {mobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-522" /> : <MenuIcon className="w-6 h-6" data-id="element-523" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && <div className="md:hidden bg-black border-t border-zinc-800 py-4 px-4 flex flex-col space-y-4 absolute w-full h-screen" data-id="element-524">
          <button onClick={() => scrollToSection('services')} className="text-left text-gray-300 font-medium py-3 border-b border-zinc-900 hover:text-white" data-id="element-525">
            Services
          </button>
          <button onClick={() => scrollToSection('how-it-works')} className="text-left text-gray-300 font-medium py-3 border-b border-zinc-900 hover:text-white" data-id="element-526">
            How It Works
          </button>
          <button onClick={() => scrollToSection('about')} className="text-left text-gray-300 font-medium py-3 border-b border-zinc-900 hover:text-white" data-id="element-527">
            About
          </button>
          <button onClick={handleApplyClick} className="w-full bg-white text-black px-6 py-4 rounded-full font-bold hover:bg-gray-200 transition-colors text-center mt-4" data-id="element-528">
            Get Started
          </button>
        </div>}
    </nav>;
}